import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";

const CTAWithIndustries = ({ data }) => {
    const [active, setActive] = useState(
        data?.industries.findIndex((i) => i.active) || 0
    );

    return (
        <section className="cta-industries-section">
            {/* Industries */}
            <Container className="cta-industries-section text-center mb-5">
                <p className="tagline">{data?.tagline}</p>
                <div className="industries-wrapper">
                    {data?.industries.map((item, index) => (
                        <Link key={index} to={item?.link} aria-label={item.name} >
                            <button
                                className={`industry-pill ${active === index ? "active" : ""}`}
                                onClick={() => setActive(index)}
                            >
                                <span className="me-2">{item.icon}</span>
                                {item.name}
                            </button>
                        </Link>
                    ))}
                </div>
            </Container>

            {/* CTA */}
            <div className="cta-box text-center">
                <Container>
                    <h2>{data?.cta?.title}</h2>
                    <p>{data?.cta?.description}</p>

                    <a
                        href={data?.cta?.buttonLink}
                        target="_blank"
                        rel="noreferrer"
                        className="cta-btn"
                    >
                        {data?.cta?.buttonText} →
                    </a>

                    <div className="cta-contact mt-4">
                        <a href={`mailto:${data?.cta?.contacts?.email}`} className="text-decoration-none text-white" aria-label={data?.cta?.contacts?.email}>
                            <span>📧 {data?.cta?.contacts?.email}  &nbsp;|&nbsp;  </span>
                        </a>
                        <a href={`tel:${data?.cta?.contacts?.phone}`} className="text-decoration-none text-white" aria-label={data?.cta?.contacts?.phone}>
                            <span>📞 {data?.cta?.contacts?.phone}  &nbsp;|&nbsp;  </span>
                        </a>
                        <a href={data?.cta?.contacts?.website} className="text-decoration-none text-white" aria-label={data?.cta?.contacts?.website} target="_blank" rel="noopener noreferrer">
                            <span>🌐 {data?.cta?.contacts?.website}</span>
                        </a>
                    </div>
                </Container>
            </div>
        </section>
    );
};

export default CTAWithIndustries;